export default function CTABanner() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20texture%20with%20soft%20organic%20shapes%20in%20terracotta%20amber%20and%20cream%20tones%2C%20elegant%20flowing%20fabric-like%20patterns%2C%20subtle%20light%20and%20shadow%20interplay%2C%20sophisticated%20minimalist%20background%2C%20editorial%20luxury%20fashion%20texture%2C%20no%20sharp%20edges&width=1600&height=600&seq=cta-bg-002&orientation=landscape"
          alt="Luxury fashion texture"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-800/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-3">
          Bereit, die besten Deals zu finden?
        </h2>
        <p className="text-sm md:text-base text-background-200/80 max-w-lg mx-auto mb-8">
          Durchstöbere 3.000+ kuratierte Produkte von verifizierten Verkäufern.
          Kostenlos nutzbar, täglich aktualisiert.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm font-semibold text-primary-800 bg-background-50 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap inline-flex items-center gap-2"
          >
            Spreadsheet durchsuchen
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-sm font-semibold text-background-50 border-2 border-background-50/60 rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap inline-flex items-center gap-2"
          >
            Jetzt kaufen
          </a>
        </div>
      </div>
    </section>
  );
}